export default "__VITE_ASSET__CW6ogu8Z__"